// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__29RgN","footer":"ModalUpdate_footer__3rX0h"};